import PDFBuilder, { fmtDate, fmtDateFromISO } from "../../utils/pdfBuilder.js";

const tipImobilLabels = {
  apartament: "apartamentul",
  casa: "casa",
  garsoniera: "garsoniera",
  spatiu_comercial: "spatiul comercial",
  birou: "biroul",
  altul: "imobilul",
};

export default function buildInchirierePDF(data, filename) {
  const pdf = new PDFBuilder();
  const today = fmtDate(new Date());

  const imobilLabel = data.imobilTip === "altul"
    ? (data.imobilTipAltul || "imobilul")
    : (tipImobilLabels[data.imobilTip] || "imobilul");
  const ascundeCamere = data.imobilTip === "spatiu_comercial" || data.imobilTip === "altul";

  const durateLuni = parseInt(data.durata) || 12;
  const dataInceputFmt = data.dataInceput ? fmtDateFromISO(data.dataInceput) : "___";
  let dataEndFmt = "___";
  if (data.dataInceput) {
    const end = new Date(data.dataInceput);
    end.setMonth(end.getMonth() + durateLuni);
    dataEndFmt = fmtDate(end);
  }

  const garantieSuma = data.chirie && data.garantie
    ? Math.round(Number(data.chirie) * Number(data.garantie))
    : "___";
  const garantieText = data.garantie === "1" ? "1 chirie lunara" : `${data.garantie || "___"} chirii lunare`;

  // Header
  pdf.title("Contract de Inchiriere", `Nr. ___ din ${today}`);

  // I. PARTILE CONTRACTANTE
  pdf.section("I. PARTILE CONTRACTANTE");

  pdf.pMixed([{ text: "1.1. Proprietarul (Locatorul):", bold: true }]);
  pdf.renderPartyPFPJ(data, "proprietar", data.proprietarPJ);

  pdf.italic("si");

  pdf.pMixed([{ text: "1.2. Chiriasul (Locatarul):", bold: true }]);
  pdf.renderPartyPFPJ(data, "chirias", data.chiriasPJ);

  pdf.intro("au convenit incheierea prezentului contract de inchiriere in urmatoarele conditii:");

  // II. OBIECTUL CONTRACTULUI
  pdf.section("II. OBIECTUL CONTRACTULUI");

  const camereText = !ascundeCamere && data.imobilCamere ? `, compus din ${data.imobilCamere} camere` : "";
  const etajText = data.imobilEtaj ? `, etajul ${data.imobilEtaj}` : "";
  pdf.pMixed([
    { text: "2.1. ", bold: true },
    { text: `Proprietarul inchiriaza Chiriasului imobilul de tip ` },
    { text: imobilLabel, bold: true },
    { text: ` situat in ${data.imobilAdresa || "____________________________"}${camereText}, cu suprafata utila de ${data.imobilSuprafata || "___"} mp${etajText}.` },
  ]);

  pdf.pMixed([
    { text: "2.2. ", bold: true },
    { text: `Imobilul se preda ${data.mobilat ? "mobilat si utilat" : "nemobilat"} conform Anexei 1 – Proces-verbal de predare-primire, care include inventarul bunurilor, starea acestora si indexurile contoarelor.` },
  ]);

  // III. DESTINATIA IMOBILULUI
  pdf.section("III. DESTINATIA IMOBILULUI");

  if (data.imobilTip === "spatiu_comercial") {
    pdf.article("3.1.", "Imobilul va fi folosit exclusiv pentru desfasurarea de activitati comerciale sau profesionale. Este interzisa folosirea spatiului ca locuinta.");
    if (data.nrMaxPersoane) {
      pdf.pMixed([
        { text: "3.2. ", bold: true },
        { text: "Numarul maxim de persoane care pot desfasura activitate in imobil este de " },
        { text: `${data.nrMaxPersoane}`, bold: true },
        { text: " persoane." },
      ]);
    }
  } else {
    pdf.article("3.1.", "Imobilul va fi folosit exclusiv ca locuinta. Este interzisa desfasurarea de activitati comerciale sau inregistrarea de sedii sociale fara acordul scris al Proprietarului.");
    pdf.pMixed([
      { text: "3.2. ", bold: true },
      { text: "Numarul maxim de persoane care pot locui in imobil este de " },
      { text: `${data.nrMaxPersoane || "___"}`, bold: true },
      { text: " persoane." },
    ]);
  }

  // IV. DURATA CONTRACTULUI
  pdf.section("IV. DURATA CONTRACTULUI");

  pdf.pMixed([
    { text: "4.1. ", bold: true },
    { text: "Contractul se incheie pe durata de " },
    { text: `${durateLuni} luni`, bold: true },
    { text: ", incepand cu data de " },
    { text: dataInceputFmt, bold: true },
    { text: " si pana la data de " },
    { text: dataEndFmt, bold: true },
    { text: "." },
  ]);

  pdf.pMixed([
    { text: "4.2. ", bold: true },
    { text: `Prelungirea se poate face doar prin acord scris (act aditional), cu minimum ${data.notificareZile || "30"} zile inainte de expirare.` },
  ]);

  // V. PRETUL SI MODALITATEA DE PLATA
  pdf.section("V. PRETUL SI MODALITATEA DE PLATA");

  pdf.pMixed([
    { text: "5.1. ", bold: true },
    { text: "Chiria lunara este de " },
    { text: `${data.chirie || "___"} ${data.valuta || "EUR"}`, bold: true },
    { text: `, platibila pana la data de ${data.ziuaPlata || "___"} a fiecarei luni.` },
  ]);

  pdf.article("5.2.", "Plata se face prin transfer bancar sau numerar, cu confirmare scrisa, cu respectarea legislatiei privind plafonul platilor in numerar.");

  pdf.pMixed([
    { text: "5.3. ", bold: true },
    { text: "Garantia este de " },
    { text: `${garantieSuma} ${data.valuta || "EUR"}`, bold: true },
    { text: ` (echivalentul a ${garantieText}), achitata la semnarea contractului.` },
  ]);

  pdf.article("5.4.", "Garantia se restituie la incetarea contractului, dupa predarea imobilului in stare corespunzatoare, minus eventualele:");
  pdf.p("- chirii restante", { indent: 8 });
  pdf.p("- utilitati restante", { indent: 8 });
  pdf.p("- daune produse", { indent: 8 });

  if (data.penalizareActiva) {
    pdf.pMixed([
      { text: "5.5. ", bold: true },
      { text: `Intarzierea la plata atrage penalitati de ${data.penalizare || "0.1"}% pe zi din suma datorata, incepand cu ziua urmatoare scadentei.` },
    ]);

    pdf.article("5.6.", "Penalitatile totale nu pot depasi valoarea chiriei restante.");
  }

  // VI. UTILITATI
  pdf.section("VI. UTILITATI");

  if (data.utilitatiIncluse) {
    pdf.article("6.1.", "Chiria lunara include costul utilitatilor (apa, gaz, energie electrica, internet), in limita unui consum rezonabil.");
  } else {
    pdf.article("6.1.", "Chiriasul suporta costul utilitatilor (energie electrica, apa, gaz, internet etc.) conform consumului real, pe baza facturilor si indexurilor contoarelor.");
    pdf.pMixed([
      { text: "6.2. ", bold: true },
      { text: `Facturile vor fi achitate in termen de maximum ${data.zilePlatUtilitati || "15"} zile de la primire.` },
    ]);
  }

  // VII. OBLIGATIILE PROPRIETARULUI
  pdf.section("VII. OBLIGATIILE PROPRIETARULUI");

  const obligatiiProprietar = [
    "Sa predea imobilul in stare corespunzatoare de folosinta.",
    "Sa asigure folosinta linistita a imobilului.",
    "Sa efectueze reparatiile majore si structurale.",
    "Sa nu tulbure folosinta Chiriasului, cu exceptia verificarilor efectuate cu preaviz de minimum 24 ore.",
    "Sa declare contractul la autoritatile competente, in conditiile legii.",
  ];
  obligatiiProprietar.forEach((text, i) => {
    pdf.pMixed([
      { text: `7.${i + 1}. `, bold: true },
      { text },
    ], { indent: 5 });
  });

  // VIII. OBLIGATIILE CHIRIASULUI
  pdf.section("VIII. OBLIGATIILE CHIRIASULUI");

  const obligatiiChirias = [
    "Sa plateasca chiria si utilitatile la termenele stabilite.",
    "Sa foloseasca imobilul cu prudenta si conform destinatiei.",
    "Sa nu aduca modificari fara acordul scris al Proprietarului.",
    "Sa permita accesul Proprietarului pentru verificari, cu preaviz de 24 ore.",
    "Sa anunte imediat orice defectiune aparuta.",
    "Sa efectueze reparatiile minore si de intretinere curenta.",
  ];
  obligatiiChirias.forEach((text, i) => {
    pdf.pMixed([
      { text: `8.${i + 1}. `, bold: true },
      { text },
    ], { indent: 5 });
  });

  // 8.7 - subinchiriere
  pdf.pMixed([
    { text: "8.7. ", bold: true },
    { text: !data.subinchirierePermisa
      ? "Este interzisa subinchirierea fara acordul scris al Proprietarului."
      : "Subinchirierea este permisa numai cu acordul scris al Proprietarului." },
  ], { indent: 5 });

  // 8.8 - interdictii
  const interdictii = [];
  if (!data.fumatPermis) interdictii.push("fumatul in interior");
  if (!data.animalePermise) interdictii.push("detinerea de animale (fara acord scris)");
  interdictii.push("schimbarea incuietorilor fara acord");

  pdf.pMixed([
    { text: "8.8. ", bold: true },
    { text: "Este interzis:" },
  ], { indent: 5 });
  interdictii.forEach((text) => {
    pdf.p(`- ${text}`, { indent: 8 });
  });

  // Dynamic numbering from 8.9
  let nr = 9;

  // fumat
  pdf.pMixed([
    { text: `8.${nr++}. `, bold: true },
    { text: data.fumatPermis
      ? "Fumatul este permis, cu obligatia chiriasului de a aerisi si de a preveni deteriorarea finisajelor."
      : "Fumatul este strict interzis in interiorul imobilului." },
  ], { indent: 5 });

  // animale (conditional)
  if (data.animalePermise) {
    pdf.pMixed([
      { text: `8.${nr++}. `, bold: true },
      { text: "Animalele de companie sunt permise, cu conditia ca acestea sa nu produca deteriorari imobilului sau disconfort vecinilor." },
    ], { indent: 5 });
  }

  // predare imobil
  pdf.pMixed([
    { text: `8.${nr}. `, bold: true },
    { text: "La incetarea contractului, Chiriasul va preda imobilul in starea initiala, mai putin uzura normala." },
  ], { indent: 5 });

  // IX. INCETAREA CONTRACTULUI
  pdf.section("IX. INCETAREA CONTRACTULUI");

  pdf.article("9.1.", "Contractul inceteaza:");
  pdf.letterItem("a", "la expirarea duratei");
  pdf.letterItem("b", "prin acordul partilor");
  pdf.letterItem("c", "prin reziliere pentru neexecutarea obligatiilor");
  pdf.letterItem("d", `prin denuntare unilaterala cu preaviz de ${data.notificareZile || "30"} zile`);

  pdf.pMixed([
    { text: "9.2. ", bold: true },
    { text: data.pierdereGarantie
      ? "Daca Chiriasul paraseste imobilul inainte de termen, garantia poate fi retinuta pentru acoperirea prejudiciilor, a chiriei restante sau a nerespectarii termenului de preaviz."
      : "Daca Chiriasul paraseste imobilul inainte de termen, plateste echivalentul unei luni de chirie drept despagubire." },
  ]);

  pdf.pMixed([
    { text: "9.3. ", bold: true },
    { text: `Neplata chiriei pentru o perioada de ${data.zileNeplatReziliere || "30"} zile consecutive atrage rezilierea de plin drept, cu notificare prealabila.` },
  ]);

  // X. RASPUNDERE
  pdf.section("X. RASPUNDERE");

  pdf.pMixed([
    { text: "10.1. ", bold: true },
    { text: "Chiriasul raspunde pentru daunele produse din culpa sa." },
  ], { indent: 5 });

  pdf.pMixed([
    { text: "10.2. ", bold: true },
    { text: "Uzura normala nu constituie dauna." },
  ], { indent: 5 });

  // XI. FORTA MAJORA
  pdf.section("XI. FORTA MAJORA");

  pdf.pMixed([
    { text: "11.1. ", bold: true },
    { text: "Forta majora exonereaza de raspundere partea care o invoca, in conditiile legii." },
  ], { indent: 5 });

  pdf.pMixed([
    { text: "11.2. ", bold: true },
    { text: "Partea care invoca forta majora are obligatia de a notifica cealalta parte in termen de 5 zile de la aparitia evenimentului." },
  ], { indent: 5 });

  // XII. LITIGII
  pdf.section("XII. LITIGII");

  pdf.pMixed([
    { text: "12.1. ", bold: true },
    { text: "Litigiile se solutioneaza pe cale amiabila, iar in caz contrar de instantele competente." },
  ], { indent: 5 });

  // XIII. DISPOZITII FINALE
  pdf.section("XIII. DISPOZITII FINALE");

  pdf.pMixed([
    { text: "13.1. ", bold: true },
    { text: "Prezentul contract poate constitui titlu executoriu numai in conditiile prevazute de lege." },
  ], { indent: 5 });

  pdf.pMixed([
    { text: "13.2. ", bold: true },
    { text: "Orice modificare se face prin act aditional." },
  ], { indent: 5 });

  pdf.pMixed([
    { text: "13.3. ", bold: true },
    { text: "Contractul se incheie in 2 exemplare originale." },
  ], { indent: 5 });

  // Signatures
  const proprietarName = pdf.getPartyNamePFPJ(data, "proprietar", data.proprietarPJ);
  const chiriasName = pdf.getPartyNamePFPJ(data, "chirias", data.chiriasPJ);

  pdf.signatures(
    { role: "PROPRIETAR", name: proprietarName, date: today },
    { role: "CHIRIAS", name: chiriasName, date: today },
  );

  pdf.save(filename);
}
